document.addEventListener("DOMContentLoaded", () => {

  // Update overlay visibility based on whether any popover is open
  function updateOverlay() {
    const overlay = document.querySelector('.popover-overlay');
    const openPopover = document.querySelector(".popover[open]");
    if (overlay) {
      if (openPopover) {
        overlay.classList.add('is-visible');
      } else {
        overlay.classList.remove('is-visible');
      }
    }
  }

  // Unified function to toggle a popover's open state
  function togglePopoverState(popover, shouldOpen) {
    // Find the corresponding button using the popover's id
    const button = document.querySelector(`[aria-controls="${popover.id}"]`);
    if (shouldOpen) {
      popover.setAttribute("open", "");
      if (button) button.setAttribute("aria-expanded", "true");
    } else {
      popover.removeAttribute("open");
      if (button) button.setAttribute("aria-expanded", "false");
    }
    // updateOverlay();
  }

  // Delegated event listener for popover interactions
  document.addEventListener("click", (e) => {
    // If a popover button is clicked, toggle its popover
    const button = e.target.closest(".popover-button");
    if (button) {
      e.stopPropagation();
      const popoverId = button.getAttribute("aria-controls");
      if (!popoverId) return;
      const popover = document.getElementById(popoverId);
      if (!popover) return;

      // Close all open popovers
      document.querySelectorAll(".popover[open]").forEach(openPopover => {
        togglePopoverState(openPopover, false);
      });

      // Open the target popover if it was not already open
      if (!popover.hasAttribute("open")) {
        togglePopoverState(popover, true);
      }
      return;
    }

    // If a popover's close button is clicked, close its parent popover
    const closeBtn = e.target.closest(".popover-close-button");
    if (closeBtn) {
      e.stopPropagation();
      const popover = closeBtn.closest(".popover");
      if (popover) {
        togglePopoverState(popover, false);
      }
      return;
    }

    // Close all open popovers when clicking outside of any popover or button
    if (!e.target.closest(".popover") && !e.target.closest(".popover-button")) {
      document.querySelectorAll(".popover[open]").forEach(popover => {
        togglePopoverState(popover, false);
      });
    }
  });

});